import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { GridSortItem } from "@mui/x-data-grid";
import { useRef } from "react";
import { LedgerControllerApi } from "../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  getXtenantId,
} from "../../../utils/utils";

interface Props {
  patientUuid: string;
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  status?: string;
  startDate?: string;
  endDate?: string;
  searchString?: string;
  xTENANTID?: string;
  enabled?: boolean;
}

/**
 *
 * @author Rajkumar Rathod
 */
export const useGetPatientLedger = ({
  patientUuid,
  pagination,
  gridSorting,
  status,
  startDate,
  endDate,
  searchString,
  xTENANTID,
  enabled = true,
}: Props) => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);
  const sortData = gridSorting?.[0];
  const tenantId = xTENANTID ?? getXtenantId();

  return useQuery({
    queryKey: [
      "get-patient-ledger",
      patientUuid,
      pageIndex,
      pageSize,
      sortData?.field,
      sortData?.sort,
      status,
      startDate,
      endDate,
      searchString,
      tenantId,
    ],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: enabled && !!patientUuid,
    queryFn: async () =>
      await new LedgerControllerApi(getConfigObject())
        .getLedgers(
          pageIndex,
          pageSize,
          sortData?.field ?? undefined,
          sortData?.sort ?? undefined,
          patientUuid,
          status,
          startDate,
          endDate,
          searchString,
          tenantId
        )
        .then((res) => res?.data),
  });
};
